import React, { useState, useEffect } from "react";
import Html from "utils/Html";
import { useMyProfile } from "context/MyProfileContext";
import MyProfileRightContentPhoto from "components/myprofile/features/content.photo";
import MyProfileRightContentInfoView from "components/myprofile/features/content.info.view";
import MyProfileRightContentInfoEdit from "components/myprofile/features/content.info.edit";
import {
  EditInfo,
  SaveInfo,
  SelectChangeInfo,
  ChangeInfo,
} from "components/myprofile/features/events";

export default function MyProfileRightContent() {
  const { infos, staffData } = useMyProfile();
  const boxName = "content-myprofile";
  const [data, setData] = useState({});
  const [saveData, setSaveData] = useState({});

  useEffect(() => {
    if (staffData?.err === 0 && staffData?.data) {
      setData(staffData.data);
    }
  }, [staffData]);

  if (staffData?.err === 1 || data?.err === 1) {
    return <div>Fetch request error: {staffData.err_msg}</div>;
  } else if (
    staffData.data === "" ||
    staffData.status !== "success" ||
    data?.idu === undefined
  ) {
    return (
      <div>
        <Html.Preloading
          addon={{
            css: {
              position: "absolute",
              top: "0",
              left: "0",
              right: "0",
              bottom: "0",
              margin: "auto",
            },
          }}
        />
      </div>
    );
  }
  // console.log("right => staffData=", staffData);
  const filterData = staffData?.data?.filterData ?? {};
  const handleEvents = {
    OnEdit: () => EditInfo(),
    OnSave: () => {
      if (data?.isSaving) return;
      SaveInfo(data, setData, saveData, setSaveData);
    },
    OnSelectChange: (evt, { id, name, value }) =>
      SelectChangeInfo(
        evt,
        { id, name, value },
        filterData,
        data,
        setData,
        saveData,
        setSaveData
      ),
    OnChange: (evt) => ChangeInfo(evt, data, setData, saveData, setSaveData),
    OnCancel: () => {
      window.location.href = "/employees/myprofile";
    },
  };
  return (
    <div
      id="myprofile-rightcontent"
      className="col s12"
      style={{ paddingLeft: "35px", paddingRight: "35px" }}
    >
      <MyProfileRightContentPhoto
        boxName={"content-employeeinfo"}
        data={data}
        handleEvents={handleEvents}
        infos={infos}
      />
      {infos?.tabActive === "myprofile" && (
        <MyProfileRightContentInfoView
          boxName={boxName}
          data={data}
          filterData={filterData}
          handleEvents={handleEvents}
        />
      )}
      {infos?.tabActive === "editmyprofile" && (
        <MyProfileRightContentInfoEdit
          boxName={boxName}
          data={data}
          filterData={filterData}
          handleEvents={handleEvents}
        />
      )}
    </div>
  );
}
